<template>
  <div class="app-background">
    <div class="banner"></div>
    <div class="infowrap">
      <div class="infos mt20 mb20">
        <div class="left">
          <div class="company-img"></div>
        </div>
        <div class="right">
          <div
            class="title"
            v-if="companyData?.companyName"
          >{{companyData.companyName}}</div>
          <div class="info">
            <template v-if="companyData?.companyName || companyData?.uscc">
              <div class="comdiv half">
                <img src="~@/assets/comp1.png" />
                <span>法人代表：</span>
                <div>{{companyData.legalRepresentative}}</div>
              </div>
              <div class="comdiv">
                <img src="~@/assets/comp3.png" />
                <span>统一社会信用代码：</span>
                <div>{{companyData.uscc}}</div>
              </div>
              <div class="comdiv">
                <img src="~@/assets/comp4.png" />
                <span>地址：</span>
                <div class="line_1">{{companyData.companyAddress}}</div>
              </div>
              <div class="comdiv long">
                <img src="~@/assets/comp5.png" />
                <span>经营范围：</span>
                <div>{{companyData.companyScope}}</div>
              </div>
              <div class="comdiv long">
                <span>荣誉称号：</span>
                <div>{{companyData.enterpriseTitle.replace(';其他','')}}{{companyData.enterpriseTitleOthers?`;其他(${companyData.enterpriseTitleOthers})`:''}}</div>
              </div>
              <div class="comdiv long">
                <span>国内有效知识产权发明数量：</span>
                <div>{{companyData.effectiveInventions || 0}}件</div>
              </div>
              <div class="comdiv long">
                <span>国内有效知识产权实用新型数量：</span>
                <div>{{companyData.effectiveUtilities || 0}}件</div>
              </div>
              <div class="comdiv long">
                <span>国内有效知识产权外观设计数量：</span>
                <div>{{companyData.effectiveDesigns || 0}}件</div>
              </div>
              <div class="comdiv long">
                <span>国内有效知识产权商标数量：</span>
                <div>{{companyData.effectiveTrademark || 0}}件</div>
              </div>
              <!-- <div class="comdiv">
              <span>荣誉称号：</span>
              <div>{{companyData.}}</div>
              </div>-->
            </template>
            <div class="comdiv">
              <span style="color:orange">以上数据均截止于{{storageYear}}年</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { companyinfo } from "@/api/index.js";
export default {
  name: "index",
  data() {
    return {
      companyData: {}
    };
  },
  created() {
    if (this.$route.query.id) {
      companyinfo(this.$route.query.id).then(res => {
        this.companyData = res.data;
      });
    }
  },
  mounted() {},
  computed: {
    storageYear() {
      const storageTime = this.companyData.storageTime;
      if (!storageTime) {
        return "";
      }

      const year = String(storageTime).match(/^\d{4}/);
      if (year) {
        return Number(year[0]) - 1;
      }

      const date = new Date(storageTime);
      return isNaN(date.getTime()) ? "" : date.getFullYear() - 1;
    }
  }
};
</script>
<style scoped lang="less">
.app-background {
  background-color: #f4f6fa;
  min-width: 1200px;
}
.infowrap {
  width: 1200px;
  margin: 20px auto 0;
  background-color: #f4f6fa;
  padding-bottom: 20px;
}
.infos {
  background-color: #fff;
  box-sizing: border-box;
  padding: 40px;
  margin-bottom: 0px;
  display: flex;
  justify-content: space-between;
  .left {
    width: 10%;
    .company-img {
      width: 100px;
      height: 100px;
      border-radius: 50%;
      background: url(../assets/comp.png);
      background-size: 100% 100%;
    }
  }
  .right {
    width: 86%;

    .title {
      height: 100px;
      width: 100%;
      font-size: 24px;
      color: #000;
      font-weight: bold;
      line-height: 100px;
      .line_1();
    }
    .info {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      .comdiv {
        width: 100%;
        box-sizing: border-box;
        padding: 10px;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        font-size: 18px;
        line-height: 28px;
        img {
          width: 18px;
          height: 18px;
          border: none;
          margin-right: 10px;
          vertical-align: middle;
        }
        span {
          color: #838383;
        }
      }
      .half {
        width: 50%;
      }
      .long {
        display: block;
        & > div {
          display: inline;
        }
      }
    }
  }
}
#banner-wrap {
  width: 100%;
  // max-width: 1200px;
  height: 520px;
  // background-color: blue;

  background-size: 100% 100%;
}
.card-wrap {
  box-sizing: border-box;
  padding: 20px;
  display: flex;
}

#mapContainer {
  height: 470px;
  width: 100%;
  margin-right: 30px;
}
.banner {
  width: 100%;
  height: 350px;
  // background-color: rgb(131, 195, 220);
  background-image: url("../assets/beijin.png");
  background-size: 100% 100%;
}
/deep/ .labelClassName {
    width: 200px;
}
</style>
